import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule, provideZonelessChangeDetection } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { APP_BASE_HREF } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { AchievementBadgeComponent } from '../../components/achievement-badge/achievement-badge.component';
import { CustomizationPickerComponent } from '../../components/customization-picker/customization-picker.component';
import { DashboardComponent } from '../../components/dashboard/dashboard.component';
import { ExploreComponent } from '../../components/explore/explore.component';
import { NpcComponent } from '../../components/explore/npc/npc.component';
import { GenericSelectorComponent } from '../../components/generic-selector/generic-selector.component';
import { InventoryComponent } from '../../components/items/inventory/inventory.component';
import { ShopEditorComponent } from '../../components/items/shops/shop-editor/shop-editor.component';
import { ShopFinderComponent } from '../../components/items/shops/shop-finder/shop-finder.component';
import { ShopViewComponent } from '../../components/items/shops/shop-view/shop-view.component';
import { ShopsManagerComponent } from '../../components/items/shops/shops-manager/shops-manager.component';
import { LoginModalComponent } from '../../components/login-modal/login-modal.component';
import { ComposeComponent } from '../../components/mailbox/compose/compose.component';
import { ConversationComponent } from '../../components/mailbox/conversation/conversation.component';
import { MailboxComponent } from '../../components/mailbox/mailbox.component';
import { MainpageComponent } from '../../components/mainpage/mainpage.component';
import { MessageBoardComposeComponent } from '../../components/message-boards/message-board-compose/message-board-compose.component';
import { MessageBoardIndexComponent } from '../../components/message-boards/message-board-index/message-board-index.component';
import { MessageBoardComponent } from '../../components/message-boards/message-board/message-board.component';
import { AnnouncementComponent } from '../../components/notifications/announcement/announcement.component';
import { ToastHostComponent } from '../../components/notifications/toast-host/toast-host.component';
import { ToastComponent } from '../../components/notifications/toasts/toast.component';
import { ProfilePetComponent } from '../../components/profile-pet/profile-pet.component';
import { ProfileComponent } from '../../components/profile/profile.component';
import { MessagePopupComponent } from '../../components/social/message-popup/message-popup.component';
import { SocialComponent } from '../../components/social/social.component';
import { SpotlightCardComponent } from '../../components/spotlight/spotlight-card/spotlight-card.component';
import { SpotlightCarouselComponent } from '../../components/spotlight/spotlight-carousel/spotlight-carousel.component';
import { SpotlightComponent } from '../../components/spotlight/spotlight/spotlight.component';
import { NewsAlertBannerComponent } from '../../components/static-content/news/news-alert-banner/news-alert-banner.component';
import { NewsTilesComponent } from '../../components/static-content/news/news-tiles/news-tiles.component';
import { StaticComponent } from '../../components/static-content/static/static.component';
import { BugReportComponent } from '../../components/ui/bug-report/bug-report.component';
import { ErrorModalComponent } from '../../components/ui/error-modal/error-modal.component';
import { MessageBodyComponent } from '../../components/ui/message-body/message-body.component';
import { CashBalanceTaskComponent } from '../../components/ui/interaction-content/cash-balance-task/cash-balance-task.component';
import { ImageNodeComponent } from '../../components/ui/interaction-content/image-node/image-node.component';
import { NodeRendererComponent } from '../../components/ui/interaction-content/node-renderer/node-renderer.component';
import { NpcStateTaskComponent } from '../../components/ui/interaction-content/npc-state-task/npc-state-task.component';
import { PlainTextNodeComponent } from '../../components/ui/interaction-content/plain-text-node/plain-text-node.component';
import { PossessionTaskComponent } from '../../components/ui/interaction-content/possession-task/possession-task.component';
import { QuestTaskRendererComponent } from '../../components/ui/interaction-content/quest-task-renderer/quest-task-renderer.component';
import { TaskProgressNodeComponent } from '../../components/ui/interaction-content/task-progress-node/task-progress-node.component';
import { TitleNodeComponent } from '../../components/ui/interaction-content/title-node/title-node.component';
import { UnknownNodeComponent } from '../../components/ui/interaction-content/unknown-node/unknown-node.component';
import { InteractorComponent } from '../../components/ui/interactor/interactor.component';
import { TutorialComponent } from '../../components/ui/tutorial/tutorial.component';
import { DomCreatedDirective } from '../../directives/dom-created.directive';
import { ShadowPopoverDirective } from '../../directives/shadow-popover.directive';
import { TelemetryErrorHandler } from '../../services/telemetry/faro-telemetry';
import { SessionCorrelationInterceptor } from '../../services/telemetry/session-correlation.interceptor';
import { CssStyleToNgStylePipe } from '../../pipes/css-to-ng-style.pipe';
import { MessagePreviewPipe } from '../../pipes/message-preview.pipe';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({ declarations: [
        AppComponent,
        DashboardComponent,
        ProfileComponent,
        SocialComponent,
        MessagePopupComponent,
        InventoryComponent,
        ShopViewComponent,
        ShopsManagerComponent,
        ShopEditorComponent,
        ToastComponent,
        ToastHostComponent,
        AnnouncementComponent,
        MailboxComponent,
        AnnouncementComponent,
        ComposeComponent,
        NpcComponent,
        ConversationComponent,
        ProfilePetComponent,
        MainpageComponent,
        LoginModalComponent,
        ShopFinderComponent,
        BugReportComponent,
        AchievementBadgeComponent,
        TutorialComponent,
        ShadowPopoverDirective,
        DomCreatedDirective,
        ErrorModalComponent,
        MessageBodyComponent,
        InteractorComponent,
        ExploreComponent,
        CssStyleToNgStylePipe,
        MessagePreviewPipe,
        GenericSelectorComponent,
        CustomizationPickerComponent,
        MessageBoardComponent,
        MessageBoardIndexComponent,
        MessageBoardComposeComponent,
        StaticComponent,
        NewsAlertBannerComponent,
        NewsTilesComponent,
        NodeRendererComponent,
        PlainTextNodeComponent,
        TitleNodeComponent,
        ImageNodeComponent,
        UnknownNodeComponent,
        QuestTaskRendererComponent,
        PossessionTaskComponent,
        CashBalanceTaskComponent,
        NpcStateTaskComponent,
        SpotlightComponent,
        SpotlightCardComponent,
        SpotlightCarouselComponent,
        TaskProgressNodeComponent
    ],
    exports: [ShadowPopoverDirective],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [SharedModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule], providers: [
        { provide: APP_BASE_HREF, useValue: environment.baseHref },
        provideHttpClient(withInterceptorsFromDi()),
        provideZonelessChangeDetection(),
        { provide: ErrorHandler, useClass: TelemetryErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: SessionCorrelationInterceptor, multi: true },
    ] })
export class AppModule { }
